function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 52,
  r: 44,
  fill: "#FA6358",
  fillOpacity: 0.15
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M82.342 37.68h16.66a3 3 0 012.999 3v16.536M65.662 37.68h-16.66a3 3 0 00-3 3v16.536M82.342 93.68h16.66a3 3 0 002.999-3V74.147M65.662 93.68h-16.66a3 3 0 01-3-3V74.147",
  stroke: "#444",
  strokeWidth: 4
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 54.336,
  y: 45.848,
  width: 10.723,
  height: 10.723,
  rx: 2,
  fill: "#444"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.147 70.696a2 2 0 00-2 2v10.298a2 2 0 002 2h10.297a2 2 0 002-2V72.696a2 2 0 00-2-2H55.147zm2.378 2.383a2 2 0 00-2 2v5.532a2 2 0 002 2h5.532a2 2 0 002-2v-5.532a2 2 0 00-2-2h-5.532zM81.36 45.674a2 2 0 00-2 2v10.298a2 2 0 002 2h10.297a2 2 0 002-2V47.674a2 2 0 00-2-2H81.36zm2.38 2.383a2 2 0 00-2 2v5.532a2 2 0 002 2h5.533a2 2 0 002-2v-5.532a2 2 0 00-2-2H83.74z",
  fill: "#444"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M81.742 76.097a2 2 0 012-2h6.724a2 2 0 012 2v6.723a2 2 0 01-2 2h-6.724a2 2 0 01-2-2v-6.723z",
  fill: "#444"
});

function SvgQrcodeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 105 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgQrcodeinline;